import React, { Component } from "react";
import { connect } from "react-redux";

import AuthProvider from "./AuthProvider";

import CustomersContainer from "./pages/customersList/CustomersListPage";
import WorkflowListPage from "./pages/workflowList/WorkflowListPage";
import SiteWorkflowViewPage from "./pages/workflowView/SiteWorkflowViewPage";
import WorkflowCreatePage from "./pages/workflowCreate/WorkflowCreatePage";
import SiteList from "./pages/siteList/SiteListPage";
import SiteAreaExportPage from "./pages/flightPlan/FlightPlanPage";
import SiteAreaEditPage from "./pages/siteAreaEdit/SiteAreaEditPage";
import SiteFlightReportRecipientsEditPage from "./pages/siteFlightReportRecipients/SiteFlightReportRecipientsEditPage";
import SiteDashboard from "./pages/dashboard/DashboardPage";
import NotFoundPage from "./NotFoundPage";

import {
  lookup,
  ROUTE_CUSTOMERS,
  ROUTE_SITES,
  ROUTE_SITE_AREA_EXPORT,
  ROUTE_SITE_AREA_EDIT,
  ROUTE_CUSTOMER_WORKFLOW,
  ROUTE_SITE_DASHBOARD,
  ROUTE_SITE_WORKFLOW,
  ROUTE_SITE_WORKFLOW_CREATE,
  ROUTE_SITE_WORKFLOW_LIST_BY_TYPE,
  ROUTE_ONBOARDING_CONTINUE,
  ROUTE_SITE_FLIGHT_REPORT_RECIPIENTS_EDIT,
  ROUTE_SITE_MATRIX_CALCULATOR,
  ROUTE_SRS_CONFIG,
} from "../redux/modules/route/routes";
import MatrixCalculatorPage from "./pages/matrixCalculator/react/MatrixCalculatorPage";
import CustomerWorkflowViewPage from "./pages/workflowView/CustomerWorkflowViewPage";
import { GlobalState } from "../redux/modules/rootReducer";
import SrsConfigurationPage from "./pages/srsConfiguration/SrsConfigurationPage";

type Props = {
  routePath: string;
  userStatus: string;
};

function mapStateToProps(state: GlobalState): Props {
  return {
    routePath: state.route,
    userStatus: state.user.status,
  };
}

export default connect(mapStateToProps)(
  class Router extends Component<Props> {
    shouldComponentUpdate(nextProps: Readonly<Props>) {
      // update component only if route changes
      return this.props.routePath !== nextProps.routePath;
    }

    render() {
      const { userStatus, routePath } = this.props;

      if (userStatus === "pending") {
        return <div>loading..</div>;
      }

      const route = lookup(routePath);

      if (!route) {
        return <NotFoundPage />;
      }

      const componentName = route.name;
      const componentProps = route.options;

      switch (componentName) {
        case ROUTE_CUSTOMERS:
          return (
            <AuthProvider>
              <CustomersContainer {...componentProps} />
            </AuthProvider>
          );
        case ROUTE_SITES:
          return (
            <AuthProvider>
              <SiteList {...componentProps} />
            </AuthProvider>
          );
        case ROUTE_SITE_DASHBOARD:
          return (
            <AuthProvider>
              <SiteDashboard
                customerId={route.options.customerId}
                siteId={route.options.siteId}
              />
            </AuthProvider>
          );
        case ROUTE_SITE_AREA_EXPORT:
          return (
            <AuthProvider>
              <SiteAreaExportPage {...componentProps} />
            </AuthProvider>
          );
        case ROUTE_SITE_AREA_EDIT:
          return (
            <AuthProvider>
              <SiteAreaEditPage {...componentProps} />
            </AuthProvider>
          );
        case ROUTE_SITE_FLIGHT_REPORT_RECIPIENTS_EDIT:
          return (
            <AuthProvider>
              <SiteFlightReportRecipientsEditPage {...componentProps} />
            </AuthProvider>
          );
        case ROUTE_SITE_MATRIX_CALCULATOR:
          return (
            <AuthProvider>
              <MatrixCalculatorPage {...componentProps} />
            </AuthProvider>
          );
        case ROUTE_SRS_CONFIG:
          return (
            <AuthProvider>
              <SrsConfigurationPage {...componentProps} />
            </AuthProvider>
          );
        case ROUTE_SITE_WORKFLOW_LIST_BY_TYPE:
          return (
            <AuthProvider>
              <WorkflowListPage
                customerId={route.options.customerId}
                siteId={route.options.siteId}
                workflowType={route.options.workflowType.toUpperCase()}
              />
            </AuthProvider>
          );
        case ROUTE_SITE_WORKFLOW_CREATE:
          return (
            <AuthProvider>
              <WorkflowCreatePage
                customerId={route.options.customerId}
                siteId={route.options.siteId}
                workflowType={route.options.workflowType}
              />
            </AuthProvider>
          );
        case ROUTE_SITE_WORKFLOW:
        case ROUTE_ONBOARDING_CONTINUE:
          return (
            <AuthProvider>
              <SiteWorkflowViewPage />
            </AuthProvider>
          );
        case ROUTE_CUSTOMER_WORKFLOW:
          return (
            <AuthProvider>
              <CustomerWorkflowViewPage />
            </AuthProvider>
          );
        default:
          return <NotFoundPage {...componentProps} />;
      }
    }
  },
);
